export default "__VITE_ASSET__CfygGwWC__"